import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';

import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
import ChapterCard from './ChapterCard';
import LoaderWrapper from '../LoaderWrapper';
import alertMessage from '../../config/alertMessage';
import ModalComponent from '../../Common/Modal';
import { examNameAccordingToDB } from '../../../common/constant';
export class Chapter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chapters: [],
      idname: '',
      token: '',
      isLoading: true,
      userSubscriptionDetails: {},
      openPremiumPopup: false,
    };
  }

  static contextTypes = { router: React.PropTypes.object };
  async componentDidMount() {
    window.scrollTo(0, 0);
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    const data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    this.fetchChapters(data)
      .then(resp => {
        this.setState({
          chapters: resp.chapters || resp.data,
          userSubscriptionDetails: resp.userSubscriptionDetails,
          isLoading: false,
        });
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  }

  fetchChapters = async data => {
    const { apiEndpoint } = this.props;
    return await FD.callAPI(App_data.backend_api + apiEndpoint, data);
  };

  onClickFunc = (item, redirectRoute) => {
    const { userSubscriptionDetails } = this.state;
    const { callingComponent } = this.props;
    if (
      (Object.keys(userSubscriptionDetails).length || redirectRoute) &&
      callingComponent !== 'notes'
    ) {
      return this.redirectToContent(item, redirectRoute);
    }
    if (
      Object.keys(userSubscriptionDetails).length ||
      (item.isFree === true && callingComponent === 'notes')
    ) {
      this.props.fetchNotesPDFById(item);
    } else {
      this.toggleAlert();
    }
  };

  redirectToContent = (item, redirectRoute) =>
    this.context.router.push({
      pathname: redirectRoute
        .replace(':index', 0)
        .replace(':chapterId', item.id)
        .replace(':listId', item.id),
    });
  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }

  toggleAlert() {
    this.setState({ openPremiumPopup: !this.state.openPremiumPopup });
  }
  render() {
    const {
      state: { chapters, showFreePremiumTag, isLoading, userSubscriptionDetails, openPremiumPopup },
      props: {
        headerImage,
        imageWidth,
        redirectRoute = '',
        callingComponent = '',
        replacementFields = {},
      },
    } = this;
    return (
      <LoaderWrapper isLoading={isLoading}>
        <Row>
          <Col className='seperator-block-wrap'>
            <div className='card'>
              <div className='card-block'>
                <Row>
                  {chapters.map(item => {
                    const {
                      'esg_questions.premiumQuestionsCount': premiumQuestionsCount,
                      'esg_questions.freeQuestionsCount': freeQuestionsCount,
                    } = item;
                    return (
                      <ChapterCard
                        onClick={() => this.onClickFunc(item, redirectRoute)}
                        key={item.id}
                        callingComponent={callingComponent}
                        headerImage={headerImage}
                        headerImageWidth={imageWidth}
                        chapterNumber={item.id}
                        chapterName={item.name || item[replacementFields.name]}
                        totalReadings={item.totalReadings}
                        totalNotes={item.totalNotes}
                        freeQuestionsCount={freeQuestionsCount}
                        premiumQuestionsCount={premiumQuestionsCount}
                        showFreePremiumTag={showFreePremiumTag}
                        userSubscriptionDetails={userSubscriptionDetails}
                        free={item.isFree}
                        {...this.props}
                      />
                    );
                  })}
                </Row>
              </div>
            </div>
            <ModalComponent
              goPremium={this.goPremium.bind(this)}
              toggleAlert={this.toggleAlert.bind(this)}
              alert_status={openPremiumPopup}
              MessageContent={alertMessage.messageContent_ESG}
              exam={examNameAccordingToDB.ESG}
            />
          </Col>
        </Row>
      </LoaderWrapper>
    );
  }
}

export default Chapter;



// WEBPACK FOOTER //
// ./src/views/ESG/Chapter/index.jsx